import t from "@/lang/lang";
import { PositionsBaseDataFieldsConfig } from "../position/components/positions-base-data-fields";
import { PositionKind } from "../position/types/position-kind";
import { OptionAvailability } from "../position/types/position-base-data";
import { omniPricesUsed } from "./omni-prices-used";

/**
 * omniPositionsBaseDataFieldsConfig configures the
 * {@link PositionsBaseDataFields} of the omni positions base data.
 * Options may be offered at every place, see `OmniPositions`,
 * backend/core/omni/domain/servicekindrules/omni_positions.go.
 * Sub-positions are text, see `OmniPositions.Validate`.
 */
export const omniPositionsBaseDataFieldsConfig: PositionsBaseDataFieldsConfig =
  {
    availabilities: [
      { value: OptionAvailability.ZeroGrouping, label: t("Ohne Gruppierung") },
      { value: OptionAvailability.Group, label: t("Gruppe") },
      { value: OptionAvailability.Area, label: t("Bereich") },
      { value: OptionAvailability.GroupArea, label: t("Gruppe & Bereich") },
    ],
    pricesUsed: omniPricesUsed,
    subPositionKinds: [PositionKind.Text],
  };
